import React, { useState, useContext } from 'react';
import { Badge, Dropdown } from 'antd';
import { LoadingOutlined, ShoppingCartOutlined, WarningOutlined } from '@ant-design/icons';
import CartContext, { CartItemProps } from 'stores/cart-context';
import CartItem from './CartItem';
import './Cart.css';
import useSaveLead from 'hooks/useSaveLead';
import { useGetUserProfileApi } from 'pages/dashboard/user/useUserApi';
import useBuildMembership from 'hooks/useBuildMembership';
import { useTranslation } from 'react-i18next';

const Cart: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { saveLead } = useSaveLead();
  const { profileObject } = useGetUserProfileApi();
  const { items, totalAmount, addItem, removeItem } = useContext(CartContext);
  const { buildMembership } = useBuildMembership();
   const { t } = useTranslation();

  const addItemToCartHandler = (item: CartItemProps) => {
    if (addItem) {
      addItem(item)
    }
  };
  
  const deleteItemFromCartHandler = (memebership: string) => {
   if (removeItem) {
    removeItem(memebership);
   }
  };
  
  const saveLeadHandler = () => {
    const membership = buildMembership(items);
    try {
      setIsLoading(true);
      saveLead(profileObject, membership);
    } catch(e) {
      setIsLoading(false);
    }
  };

  const handleVisibleChange = (flag: boolean) => {
    setVisible(flag);
  }

  const menu = (
    <div className="cart-dropdown">
      {items.length > 0 && (
        <ul className="shopping-cart">
          {items.map(item => (
            <CartItem
              key={item.membership}
              item={item}
              onAdd={addItemToCartHandler.bind(null, item)}
              onRemove={deleteItemFromCartHandler.bind(null, item.membership)}
            />
          ))}
        </ul>
      )}
      {items.length === 0 && <p className="cart-empty"><WarningOutlined />  {t('cart.empty_cart')}</p>}
      {items.length > 0 && (
        <div className="cart-total">
           {t('cart.total')}: <strong>{totalAmount.toLocaleString('tw-TW')} 元</strong>
          <div className="cart-footer">
            <button
              type="button"
              className="btn-payment"
              onClick={saveLeadHandler}
            >
              {t('cart.payment')}
              {isLoading && <span className="icon-loading"><LoadingOutlined /></span>}
            </button>
          </div>
        </div>
      )}
    </div>
  );
  
  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      onVisibleChange={handleVisibleChange}
      visible={visible}
    >
      <button className="cart-icon">
        <Badge count={items.length > 0 ? items.length : 0}>
          <ShoppingCartOutlined style={{ fontSize: '26px'}} />
        </Badge>
      </button>
    </Dropdown>
  )
}

export default Cart;
